/**
 * 会员管理
 */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.module.scss';
import { XInput, XSelect, XDatePicker, XOKButton, XCancelButton } from '@/components/xqxc_ui';
import TableContent from './components/TableContent';
import KeepAlive from '@/routes/KeepAlive';
import { SearchBox, SearchItem } from '@/components/Layout';
import { autoPageNum, autopageSize } from '@/assets/config';
import model from '@/reducers/user/member/model';
import { connect } from 'react-redux';
import { message } from 'antd';
import http from '@/assets/api/http';
import StateUpdateModal from './modal/StateUpdateModal';
import { setBreadcrumbPaths } from '@/reducers/home/actions';
import TemplateModal from '../modal/TemplateModal';
import CouponModal from '../../modal/CouponModal';
import TakeCodeModal from './modal/TakeCodeModal';
import PullCodeModal from './modal/PullCodeModal';

class Main extends React.Component {

    state = {
        openModalType: '',
        openModalParam: {},
        selectedRowKeys: [],
        selectedRows: [],

        tel: '',  // 手机号码
        realName: '', // 姓名
        status: {}, // 会员状态
        benginRegisterTime: undefined, // 注册开始时间
        endRegisterTime: undefined, // 注册结束时间
        cardNum: '', // 身份证号码
        isZoneEnum: [{ code: 1, value: '是' }, { code: 0, value: '否' }],
        isZone: {},
        isBindSmalltransportEnum: [{ code: 1, value: '是' }, { code: 0, value: '否' }],
        isBindSmalltransport: {},
    };

    componentDidMount() {
        this.props.getMemberState();
    }

    // 渲染弹窗
    _renderModal = () => {
        const { openModalType, openModalParam } = this.state;
        switch (openModalType) {
            case 'disable':
                return <StateUpdateModal visible={true} data={openModalParam} closeModal={this._closeModal} />;
            case 'template':
                return <TemplateModal visible={true} data={openModalParam} closeModal={this._closeModal} />;
            case 'coupon':
                return <CouponModal visible={true} data={openModalParam} closeModal={this._closeModal} />;
            case 'takecode':
                return <TakeCodeModal data={openModalParam} closeModal={this._closeModal} />;
            case 'pullcode':
                return <PullCodeModal data={openModalParam} closeModal={this._closeModal} />;
            default:
                return null;
        }
    }

    // 关闭弹窗
    _closeModal = (update) => {
        this.setState({ openModalType: '', openModalParam: {} }, () => {
            if (update) {
                this._searchHandle('useCache');
            }
        });
    }

    // 表格操作
    _tableAction = (type, record) => {
        const { history, curTabID } = this.props;
        let disable;
        switch (type) {
            case 'detail':
                sessionStorage.setItem('user-member', curTabID);
                history.push({ pathname: `/home/user/member/companyDetail/${record.userId}/${record.id}` });
                break;
            case 'available': // 启用禁用
                disable = record.status == 'DISABLE' || record.status == 'BLACK' ? true : false;
                if (disable) {
                    // 启用
                    http('/?cmd=com.xqxc.api.pig.mis.biz.account.EnterpriseAccountMisService.updateEnterpriseBrokerStatus', {
                        userId: record.userId,
                        status: 'ENABLE'
                    }, 'POST').then(() => {
                        message.success('启用成功');
                        this.setState({ openModalType: '', openModalParam: {} }, () => {
                            this._searchHandle('useCache');
                        });
                    }).catch((e) => {
                        message.error(e.message);
                    });
                } else {
                    // 禁用
                    this.setState({ openModalType: 'disable', openModalParam: { userId: record.userId } });
                }
                break;
            case 'template':
                this.setState({ openModalType: 'template', openModalParam: { id: record.id } });
                break;
            case 'templateDetail':
                sessionStorage.setItem('user-member', curTabID);
                history.push({ pathname: '/home/user/member/shippingfeeset/2/' + record.epDeliveryFeeRuleId });
                break;
            case 'takecode':
                this.setState({ openModalType: 'takecode', openModalParam: { record } });
                break;
            case 'pullcode':
                this.setState({ openModalType: 'pullcode', openModalParam: { record } });
                break;
        }
    }

    // 查询触发
    _searchHandle = (useCache) => {
        const { pageNum, pageSize, tel, realName, benginRegisterTime, endRegisterTime, cardNum, status, isZone, isBindSmalltransport } = this.state;
        const query = {
            tel,
            epName: realName,
            benginRegisterTime,
            endRegisterTime,
            cardNum,
            zoneFlag: isZone.code,
            smallTransportFlag: isBindSmalltransport.code,
            status: status.code ? status.code : undefined,
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum,
            pageSize: useCache == 'useCache' ? pageSize : autopageSize,
        };
        if (process.env.TYPE == 'OC') {
            this.props.getCompanyListV2(query);
        } else {
            this.props.getCompanyList(query);
        }

        KeepAlive.saveCache({ ...this.state, pageNum: query.pageNum, pageSize: query.pageSize });
    }

    // 重置触发
    _resetHandle = () => {
        this.setState({ tel: '', realName: '', benginRegisterTime: undefined, endRegisterTime: undefined, cardNum: '', status: {}, isZone: {}, isBindSmalltransport: {} }, () => {
            KeepAlive.saveResetFunc(this._searchHandle);
        });
    }

    // 每页pageSize条，当前第pageNum页
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageSize, pageNum }, () => {
            this._searchHandle('useCache');
        });
    }

    _sendCoupon = () => {
        if (this.state.selectedRowKeys.length === 0) {
            message.warning('请选择要发放的用户');
            return;
        }
        this.setState({ openModalType: 'coupon', openModalParam: { ids: this.state.selectedRowKeys } });
    }

    // 表格复选输入
    _rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            this.setState({ selectedRowKeys, selectedRows });
        },
    };

    render() {
        const { tel, realName, status, benginRegisterTime, endRegisterTime, cardNum, isZoneEnum, isZone, isBindSmalltransportEnum, isBindSmalltransport } = this.state;
        const { companyList, companyListV2, memberState, curTabID } = this.props;
        const dataList = process.env.TYPE == 'OC' ? companyListV2 : companyList

        return (
            <>
                <KeepAlive id={curTabID} render={(state) => {
                    if (!this.state.__aliveInit) {
                        this.setState({ ...state, __aliveInit: true }, () => {
                            this._searchHandle('useCache');
                        });
                    }
                }}>
                    <div className={styles.flexBoxContainer}>
                        <SearchBox>
                            <SearchItem>
                                <XInput
                                    label='手机号码'
                                    placeholder='请输入'
                                    value={tel}
                                    bindThis={this}
                                    bindName='tel'
                                    maxLength={11}
                                    mode='number'
                                />
                            </SearchItem>
                            <SearchItem>
                                <XInput
                                    label='企业名称'
                                    placeholder='请输入'
                                    value={realName}
                                    bindThis={this}
                                    bindName='realName'
                                    maxLength={56}
                                    mode='chiLetNum'
                                />
                            </SearchItem>
                            {
                                process.env.TYPE == 'OC' ? null : <>
                                    <SearchItem>
                                        <XSelect
                                            label='关联区域'
                                            placeholder='请选择'
                                            renderData={isZoneEnum}
                                            dataIndex='value'
                                            keyIndex='code'
                                            value={isZone.value}
                                            bindThis={this}
                                            bindName='isZone'
                                            showSearch={true}
                                        />
                                    </SearchItem>
                                    <SearchItem>
                                        <XSelect
                                            label='绑定站点'
                                            placeholder='请选择'
                                            renderData={isBindSmalltransportEnum}
                                            dataIndex='value'
                                            keyIndex='code'
                                            value={isBindSmalltransport.value}
                                            bindThis={this}
                                            bindName='isBindSmalltransport'
                                            showSearch={true}
                                        />
                                    </SearchItem>
                                </>
                            }
                            <SearchItem>
                                <XSelect
                                    label='会员状态'
                                    placeholder='请选择'
                                    renderData={memberState}
                                    dataIndex='value'
                                    keyIndex='code'
                                    value={status.value}
                                    bindThis={this}
                                    bindName='status'
                                    showSearch={true}
                                />
                            </SearchItem>
                            <SearchItem>
                                <XDatePicker
                                    label='注册时间'
                                    value={benginRegisterTime}
                                    bindThis={this}
                                    bindName='benginRegisterTime'
                                    showTime={false}
                                    defaultTime='00:00:00'
                                />
                                <XDatePicker
                                    style={{ marginRight: '20px' }}
                                    label=''
                                    value={endRegisterTime}
                                    bindThis={this}
                                    bindName='endRegisterTime'
                                    showTime={false}
                                    defaultTime='23:59:59'
                                />
                            </SearchItem>
                            <SearchItem>
                                <XInput
                                    label='身份证号'
                                    placeholder='请输入'
                                    value={cardNum}
                                    bindThis={this}
                                    bindName='cardNum'
                                    maxLength={18}
                                />
                            </SearchItem>
                            <SearchItem>
                                <XOKButton
                                    label='查询'
                                    onClick={this._searchHandle}
                                />
                                <XCancelButton
                                    label='重置'
                                    onClick={this._resetHandle}
                                />
                            </SearchItem>
                        </SearchBox>
                        {
                            process.env.TYPE == 'OC' ? null : <div style={{ marginTop: 5 }}>
                                <XOKButton
                                    style={{ width: '100px' }}
                                    label='发放卡券'
                                    onClick={this._sendCoupon}
                                />
                            </div>
                        }
                        <TableContent
                            rowSelection={this._rowSelection}
                            renderData={dataList}
                            tableAction={this._tableAction}
                            paginationChange={this._paginationChange}
                        />
                    </div>
                </KeepAlive>
                {this._renderModal()}
            </>
        );
    }
}

Main.propTypes = {
    match: PropTypes.object,
    history: PropTypes.object, // 路由
    curTabID: PropTypes.string,
    getCompanyList: PropTypes.func,
    getCompanyListV2: PropTypes.func,
    companyList: PropTypes.object,
    companyListV2: PropTypes.object,
    getMemberState: PropTypes.func,
    memberState: PropTypes.array,
    setBreadcrumbPaths: PropTypes.func,
};

const mapStateToProps = (state) => ({
    companyList: state.member.getCompanyList,
    companyListV2: state.member.getCompanyListV2,
    memberState: state.member.getMemberState,
});
export default connect(mapStateToProps, { ...model.actions, setBreadcrumbPaths })(Main);